import gql from 'graphql-tag'
import { APPRAISAL_RECORD, V2_PERFORMANCE_CONVERSATION, V2_PERFORMANCE_EXPECTATION } from '../fragments/performance'

export const APPRAISAL_ADD_FRAMEWORK = gql`
  mutation appraisalAddFramework($schoolId: Int!, $standardCode: String!) {
    appraisalAddFramework(schoolId: $schoolId, standardCode: $standardCode) {
      id
      name
      standardCode
      appraisalSchedules {
        startDate
        endDate
      }
    }
  }
`

export const APPRAISAL_CREATE_FRAMEWORK = gql`
  mutation appraisalCreateFramework($input: AppraisalFrameworkInput!) {
    appraisalCreateFramework(input: $input) {
      id
      name
      standardCode
    }
  }
`

export const APPRAISAL_UPDATE_FRAMEWORK = gql`
  mutation appraisalUpdateFramework($id: Int!, $input: AppraisalFrameworkInput!) {
    appraisalUpdateFramework(id: $id, input: $input) {
      id
      name
      appraisals {
        id
        name
      }
    }
  }
`

export const APPRAISAL_BULK_UPDATE_FRAMEWORK = gql`
  mutation appraisalFrameworkBulkUpdate($ids: [Int]!, $status: AppraisalFrameworkStatus) {
    appraisalFrameworkBulkUpdate(ids: $ids, status: $status)
  }
`

export const APPRAISAL_SAVE_RECORD = gql`
  mutation appraisalSaveRecord($appraisalRecordId: Int!, $appraisalRecordInput: AppraisalRecordInput!) {
    appraisalSaveRecord(appraisalRecordId: $appraisalRecordId, appraisalRecordInput: $appraisalRecordInput) {
      ...AppraisalRecord
      appraisal {
        name
        description
        standard
        type
        appraisalFields {
          children {
            children {
              children {
                children {
                  description
                  name
                  parentId
                }
                description
                name
                parentId
              }
              description
              name
              parentId
            }
            description
            name
            parentId
          }
          description
          name
          parentId
        }
        appraisalFramework {
          name
          frequency
          appraisalSchedules {
            startDate
            endDate
          }
        }
      }
    }
  }
  ${APPRAISAL_RECORD}
`

export const APPRAISAL_SUBMIT_RECORD = gql`
  mutation appraisalSubmitRecord($appraisalRecordId: Int!, $appraisalRecordInput: AppraisalRecordInput!) {
    appraisalSubmitRecord(appraisalRecordId: $appraisalRecordId, appraisalRecordInput: $appraisalRecordInput) {
      ...AppraisalRecord
      appraisal {
        name
        description
        standard
        type
        appraisalFields {
          children {
            children {
              children {
                children {
                  description
                  name
                  parentId
                }
                description
                name
                parentId
              }
              description
              name
              parentId
            }
            description
            name
            parentId
          }
          description
          name
          parentId
        }
        appraisalFramework {
          name
          frequency
          appraisalSchedules {
            startDate
            endDate
          }
        }
      }
    }
  }
  ${APPRAISAL_RECORD}
`

export const APPRAISAL_FINALIZE_RECORD = gql`
  mutation appraisalFinalize($appraisalAssignId: Int!) {
    appraisalFinalize(appraisalAssignId: $appraisalAssignId) {
      id
    }
  }
`
export const APPRAISAL_ASSIGN = gql`
  mutation appraisalAssign($appraisalId: Int!, $personalProfileId: Int!) {
    appraisalAssign(appraisalId: $appraisalId, personalProfileId: $personalProfileId) {
      id
    }
  }
`
export const APPRAISAL_DEACTIVATE = gql`
  mutation appraisalDeactivateFramework($appraisalFrameworkId: Int!, $personalProfileId: Int!, $schoolId: Int!) {
    appraisalDeactivateFramework(
      appraisalFrameworkId: $appraisalFrameworkId
      personalProfileId: $personalProfileId
      schoolId: $schoolId
    )
  }
`

export const APPRAISAL_FRAMEWORK_BULK_UPDATE = gql`
  mutation appraisalFrameworkBulkUpdate($ids: [Int]!, $status: AppraisalFrameworkStatus!) {
    appraisalFrameworkBulkUpdate(ids: $ids, status: $status)
  }
`

export const APPRAISAL_DUPLICATE_FRAMEWORK = gql`
  mutation appraisalDuplicateFrameworks($ids: [Int]!) {
    appraisalDuplicateFrameworks(ids: $ids) {
      id
      name
      appraisals {
        id
        name
        standard
        type
        description
      }
      status {
        status
      }
      standardCode
      updatedAt
      frequency
      applyToFutureYear
      appraisalSchedules {
        startDate
        endDate
      }
    }
  }
`
export const APPRAISAL_DUPLICATE_FRAMEWORK_STANDARD = gql`
  mutation appraisalDuplicateStandard($schoolId: Int!, $standardCode: String!) {
    appraisalDuplicateStandard(schoolId: $schoolId, standardCode: $standardCode) {
      id
    }
  }
`
export const APPRAISAL_ASSIGN_STAFFS = gql`
  mutation appraisalAssignStaffs($appraisalId: Int!, $personalProfileIds: [Int]!, $date: Date) {
    appraisalAssignStaffs(appraisalId: $appraisalId, personalProfileIds: $personalProfileIds, date: $date) {
      id
    }
  }
`

export const APPRAISAL_UPDATE_ASSIGN_STAFFS = gql`
  mutation appraisalAssignsUpdate($appraisalId: Int, $appraisalAssignIds: [Int], $date: Date, $remove: Boolean) {
    appraisalAssignsUpdate(
      appraisalId: $appraisalId
      appraisalAssignIds: $appraisalAssignIds
      date: $date
      remove: $remove
    ) {
      id
    }
  }
`

export const ADD_APPRAISAL_SCHEDULE = gql`
  mutation appraisalScheduleAdd($input: AppraisalScheduleInput!, $schoolId: Int!) {
    appraisalScheduleAdd(input: $input, schoolId: $schoolId) {
      endDate
      id
      name
      startDate
    }
  }
`

export const UPDATE_APPRAISAL_SCHEDULE = gql`
  mutation appraisalScheduleUpdate($id: Int!, $input: AppraisalScheduleInput!) {
    appraisalScheduleUpdate(id: $id, input: $input) {
      endDate
      id
      name
      startDate
    }
  }
`

export const REMOVE_APPRAISAL_SCHEDULE = gql`
  mutation appraisalScheduleRemove($id: Int!) {
    appraisalScheduleRemove(id: $id)
  }
`

export const UPDATE_APPRAISAL_REVIEW_PROCESS = gql`
  mutation appraisalReviewProcessUpdate($input: ReviewProcessInput!) {
    appraisalReviewProcessUpdate(input: $input) {
      changesToFinalised
      lock
      masterLocked
      schoolId
      showHideContent
    }
  }
`

export const APPRAISAL_SIGN_OFF = gql`
  mutation appraisalSignOff($appraisalAssignId: Int!, $confirmationMetadata: Json) {
    appraisalSignOff(appraisalAssignId: $appraisalAssignId, confirmationMetadata: $confirmationMetadata) {
      id
    }
  }
`

export const APPRAISAL_SAVE_REASON_FOR_UPDATE = gql`
  mutation appraisalSaveReasonForUpdate(
    $appraisalAssignId: Int!
    $activityStatus: UserActivityAction!
    $reason: String
  ) {
    appraisalSaveReasonForUpdate(
      appraisalAssignId: $appraisalAssignId
      activityStatus: $activityStatus
      reason: $reason
    ) {
      id
      userId
      action
      targetType
      schoolId
      targetId
      changes
    }
  }
`

export const V2_PERFORMANCE_UPDATE_CHECKLIST_EVALUATION_STATUS = gql`
  mutation v2PerformanceUpdateChecklistEvaluationStatus($id: Int!, $input: V2UpdateChecklistEvaluationInput!) {
    v2PerformanceUpdateChecklistEvaluationStatus(id: $id, input: $input) {
      id
    }
  }
`

export const V2_PERFORMANCE_UPDATE_CHECKLIST_RECORD = gql`
  mutation v2PerformanceUpdateChecklistRecord($id: Int!, $input: V2UpdateChecklistRecordInput!) {
    v2PerformanceUpdateChecklistRecord(id: $id, input: $input) {
      id
    }
  }
`

export const V2_PERFORMANCE_UPDATE_COMMENT = gql`
  mutation v2PerformanceUpdateComment($comment: String, $id: Int!) {
    v2PerformanceUpdateComment(comment: $comment, id: $id) {
      comment
      id
    }
  }
`

export const V2_PERFORMANCE_CREATE_COMMENT = gql`
  mutation v2PerformanceCreateComment(
    $comment: String
    $performanceChecklistEvaluationId: Int
    $performanceChecklistItemRecordId: Int
    $type: PerformanceCommentType!
  ) {
    v2PerformanceCreateComment(
      comment: $comment
      performanceChecklistEvaluationId: $performanceChecklistEvaluationId
      performanceChecklistItemRecordId: $performanceChecklistItemRecordId
      type: $type
    ) {
      id
      author {
        id
        name
        media {
          url
        }
      }
      comment
      updatedAt
    }
  }
`

export const V2_PERFORMANCE_UNASSIGN_CHECKLIST = gql`
  mutation v2PerformanceChecklistAssignRemoveStaffs(
    $personalProfileIds: [Int!]!
    $checklistIdsToBeRemovedFrom: [Int!]!
  ) {
    v2PerformanceChecklistAssignRemoveStaffs(
      personalProfileIds: $personalProfileIds
      checklistIdsToBeRemovedFrom: $checklistIdsToBeRemovedFrom
    ) {
      status
    }
  }
`

export const V2_PERFORMANCE_BULK_UPDATE_CHECKLIST_EVALUATION_STATUS = gql`
  mutation v2PerformanceBulkUpdateChecklistEvaluationStatus($ids: [Int!]!, $input: V2UpdateChecklistEvaluationInput!) {
    v2PerformanceBulkUpdateChecklistEvaluationStatus(ids: $ids, input: $input) {
      status
    }
  }
`

export const V2_PERFORMANCE_EVALUATIONS_TAKE_ACTION = gql`
  mutation v2PerformanceEvaluationsTakeAction($ids: [Int!]!, $input: V2ChecklistEvaluationActionInput!) {
    v2PerformanceEvaluationsTakeAction(ids: $ids, input: $input) {
      status
    }
  }
`

export const V2_PERFORMANCE_CREATE_CONVERSATION = gql`
  mutation v2PerformanceCreateConversation(
    $message: String
    $performanceChecklistEvaluationId: Int
    $performanceChecklistItemId: Int
  ) {
    v2PerformanceCreateConversation(
      message: $message
      performanceChecklistEvaluationId: $performanceChecklistEvaluationId
      performanceChecklistItemId: $performanceChecklistItemId
    ) {
      ...PerformanceConversation
    }
  }
  ${V2_PERFORMANCE_CONVERSATION}
`

export const V2_PERFORMANCE_UPDATE_CONVERSATION = gql`
  mutation v2PerformanceUpdateConversation($id: Int!, $message: String) {
    v2PerformanceUpdateConversation(id: $id, message: $message) {
      ...PerformanceConversation
    }
  }
  ${V2_PERFORMANCE_CONVERSATION}
`

export const V2_PERFORMANCE_CREATE_CHECKLIST_EXPECTATION = gql`
  mutation v2PerformanceCreateChecklistExpectation(
    $isFailedExpectation: Boolean
    $performanceChecklistEvaluationId: Int
    $performanceChecklistItemId: Int
  ) {
    v2PerformanceCreateChecklistExpectation(
      isFailedExpectation: $isFailedExpectation
      performanceChecklistEvaluationId: $performanceChecklistEvaluationId
      performanceChecklistItemId: $performanceChecklistItemId
    ) {
      ...PerformanceExpectation
    }
  }
  ${V2_PERFORMANCE_EXPECTATION}
`

export const V2_PERFORMANCE_UPDATE_CHECKLIST_EXPECTATION = gql`
  mutation v2PerformanceUpdateChecklistExpectation($isFailedExpectation: Boolean, $id: Int!) {
    v2PerformanceUpdateChecklistExpectation(isFailedExpectation: $isFailedExpectation, id: $id) {
      ...PerformanceExpectation
    }
  }
  ${V2_PERFORMANCE_EXPECTATION}
`

export const V2_PERFORMANCE_CREATE_CHECKLIST = gql`
  mutation v2PerformanceCreateChecklist($input: V2CreateChecklistInput!) {
    v2PerformanceCreateChecklist(input: $input) {
      id
      roleName
      roleGroup
      school {
        name
      }
      performanceChecklistItems {
        id
        name
        description
        order
        parentId
        hint
        inputSettings
      }
    }
  }
`

export const V2_PERFORMANCE_CREATE_FRAMEWORK = gql`
  mutation v2PerformanceCreateFramework($input: V2CreateFrameworkInput!) {
    v2PerformanceCreateFramework(input: $input) {
      id
      name
      status
    }
  }
`

export const V2_PERFORMANCE_UPDATE_FRAMEWORK_WORKFLOW = gql`
  mutation v2PerformanceUpdateFramework($id: Int!, $input: V2UpdateFrameworkInput!) {
    v2PerformanceUpdateFramework(id: $id, input: $input) {
      id
      name
      stateSettings
    }
  }
`

export const V2_PERFORMANCE_CREATE_APPRAISER_ROLES = gql`
  mutation v2PerformanceCreateAppraiserRoles($inputs: [V2CreateAppraiserRoleInput!]!) {
    v2PerformanceCreateAppraiserRoles(inputs: $inputs) {
      id
      name
      type
    }
  }
`

export const V2_PERFORMANCE_CREATE_PERIODS = gql`
  mutation v2PerformanceCreatePeriods($inputs: [V2PerformanceCreatePeriodInputs!]!) {
    v2PerformanceCreatePeriods(inputs: $inputs) {
      id
      name
      startDate
      endDate
    }
  }
`

export const V2_PERFORMANCE_UPDATE_CHECKLIST = gql`
  mutation v2PerformanceUpdateChecklist($id: Int!, $input: V2UpdateChecklistInput!) {
    v2PerformanceUpdateChecklist(id: $id, input: $input) {
      roleName
      roleGroup
      school {
        name
      }
      performanceChecklistItems {
        id
        name
        description
        order
        parentId
        hint
        inputSettings
      }
    }
  }
`

export const V2_PERFORMANCE_CHECKLIST_ASSIGN_STAFFS = gql`
  mutation v2PerformanceChecklistAssignStaffs($input: V2CreateChecklistAssignInput!) {
    v2PerformanceChecklistAssignStaffs(input: $input) {
      id
      status
      values
      personalProfile {
        id
        userId
        name
      }
      performanceChecklist {
        id
        roleName
        roleGroup
        description
      }
      performanceChecklistAppraiserAssignments {
        id
        performanceAppraiserRole {
          id
          name
          type
        }
        personalProfile {
          id
          userId
          name
        }
        performancePeriod {
          id
          name
          startDate
          endDate
        }
      }
    }
  }
`

export const V2_ADMIN_PERFORMANCE_DELETE_FRAMEWORK = gql`
  mutation v2AdminPerformanceDeleteFramework($id: Int!) {
    v2AdminPerformanceDeleteFramework(id: $id) {
      status
    }
  }
`
